export default __webpack_public_path__ + "static/media/PartyStarterlogo.6df90b78.png";